import React from 'react'
import Row from '@amzn/meridian/row'
import Column from '@amzn/meridian/column'
import Text from '@amzn/meridian/text'
import Toggle from '@amzn/meridian/toggle'

interface IToggleSettingProps {
    label: string
    description: string
    checked: boolean
    onChange: (checked: boolean) => void
    testId?: string
}

/**
 * A toggle setting row with label, description text, and a toggle switch.
 * Uses Meridian spacing tokens instead of custom CSS padding.
 */
export const ToggleSetting: React.FC<IToggleSettingProps> = ({
    label,
    description,
    checked,
    onChange,
    testId,
}) => {
    return (
        <Column spacingInset="300 none" data-testid={testId}>
            <Row alignmentVertical="center" widths={['fill', 'fit']}>
                <Column spacing="none">
                    <Text type="b300">{label}</Text>
                    <Text type="b200" color="secondary">{description}</Text>
                </Column>
                <Toggle checked={checked} onChange={onChange} aria-label={label} />
            </Row>
        </Column>
    )
}
